import Swiper from 'swiper'
import { Pagination, Navigation, Mousewheel } from 'swiper/modules'
import {mousewheel} from '@/scripts/core/global'

document.addEventListener('DOMContentLoaded', () => {
	const sliders = document.querySelectorAll<HTMLElement>('.js-large-slider')

	sliders?.forEach(slider => {
		const prevEl = slider.querySelector<HTMLElement>('.swiper-button-prev')
		const nextEl = slider.querySelector<HTMLElement>('.swiper-button-next')
		const paginationEl =
			slider.querySelector<HTMLElement>('.swiper-pagination')

		new Swiper(slider, {
			modules: [Pagination, Navigation, Mousewheel],
			slidesPerView: 1.05,
			mousewheel,
			navigation: {
				prevEl,
				nextEl,
			},
			pagination: {
				el: paginationEl,
				clickable: true,
			},
			breakpoints: {
				990: {
					slidesPerView: 1.6,
				},
			},
		})
	});
})